var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"loading"}},[_c('img',{attrs:{"src":require("@/assets/img/loading.svg")}})])
}]

export { render, staticRenderFns }